import DAY_OPTIONS from './options/DAY_OPTIONS';
import MONTH_OPTIONS from './options/MONTH_OPTIONS';

/**
 * Service that will fetch all the days and months
 * available for jangl-capture-forms
 */
export class DateService {

    constructor() { }

    getDaysOptions() { return  DAY_OPTIONS; }
    getMonthsOptions() { return  MONTH_OPTIONS; }
}



// WEBPACK FOOTER //
// ./app/jangl/DateService.js